import { MenuSection } from '../menu';

export type { MenuSectionProps as DropdownHeaderProps } from '../menu';

/**
 * DropdownHeader - renders header content at the top of a dropdown menu
 *
 * Re-exports MenuSection for use within Dropdown.
 *
 * @example
 * ```tsx
 * <DropdownMenu>
 *   <DropdownHeader>Actions</DropdownHeader>
 *   <DropdownMenuItem id="edit">Edit</DropdownMenuItem>
 * </DropdownMenu>
 * ```
 */
export const DropdownHeader = MenuSection;
